import { Grid, Typography } from "@mui/material";
import { styled as styling } from "@mui/material/styles";

export const GridStyledTagline = styling(Grid)((props) => ({
  width: "100%",
  padding: "80px 100px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "240px",
  // maxWidth: "1440px",
  margin: "auto",

  [props.theme.breakpoints.down("lg")]: {
    padding: "40px 24px",
    gap: "120px",
    // height: "530px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "40px 24px",
    gap: "120px",
    width: "360px",
  },
}));

export const GridStyledTaglineDefault = styling(Grid)((props) => ({
  width: "100%",
  padding: "80px 100px 80px 100px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "240px",
  maxWidth: "1440px",
  margin: "auto",

  [props.theme.breakpoints.down("lg")]: {
    padding: "80px 24px",
    gap: "120px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "64px 16px",
    gap: "120px",
  },
}));

export const GridTagline = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  gap: "14px",
  width: "100%",
  maxWidth: "1440px",
}));

export const TaglineOverline = styling(Typography)((props) => ({
  color: "#512ACC",
  fontSize: "14px",
  fontWeight: "700",
  lineHeight: "20px",
  letterSpacing: "1.5px",
  textTransform: "uppercase",

  [props.theme.breakpoints.down("lg")]: {
    // fontSize: "32px",
    // lineHeight: "40px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    // fontSize: "20px",
    // lineHeight: "24px",
  },
}));

export const TaglineTitle = styling(Typography)((props) => ({
  color: "#40249B",
  fontSize: "48px",
  fontWeight: "400",
  lineHeight: "56px",
  letterSpacing: "unset",
  fontFamily: "Inter",

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "32px",
    lineHeight: "41.6px",
    alignSelf: "stretch",
    textAlign: "center",
    fontWeight: "500",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontWeight: "500",
    lineHeight: "41.6px",
    fontSize: "32px",
  },
}));

export const TaglineSubtitle = styling(Typography)((props) => ({
  color: "#40249B",
  fontFamily: "Inter",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "40px",
  alignSelf: "stretch",

  [props.theme.breakpoints.down("lg")]: {
    lineHeight: "27px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    // fontSize: "20px",
    // lineHeight: "24px",
  },
}));
